// removed by extract-text-webpack-plugin
module.exports = {"container":"_3sVRiPA3-HtS3u18u08hMs_0","card":"FJC6_TQsQ4W1IO-vmCRvH_0","title":"_3M-mHdbTZkUbTQoUm3o81V_0","item":"_1pKJNwqXMxP87gK3LUiv1o_0","location":"_1jeEXUTEwjpZkelqTA3TFl_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-09a44d08","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/CreateBrewery.vue
// module id = nn+q
// module chunks = 1